import styled from 'styled-components'
// components
import { Button as ButtonOrigin } from 'components/UI'
// themes
import { colors } from 'themes/index'

export const ContentContainer = styled('div')`
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const Button = styled(ButtonOrigin)`
  margin-top: 16px;
`

export const TableDescription = styled('div')`
  color: ${colors.gray400};
  font-size: 14px;
  margin: 24px 0;
`
